/**
 * @file: useInboxNavigation.ts
 *
 * Typed access to the inbox stack navigator + the common open-intents as
 * ready-to-use callback hooks, so screens/components don't re-spell them.
 *
 * Search/settings open the transient overlay (`overlay$`, rendered by
 * `InboxOverlayHost`) on both form factors — a sheet on mobile, a centred card
 * on desktop — rather than pushing a full-screen screen.
 */

import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';
import { useInboxContext } from '../context';
import { InboxNavParams } from '../screens';

export const useInboxNavigation = () =>
  useNavigation<StackNavigationProp<InboxNavParams>>();

export const useOpenInboxSettings = () => {
  const { overlay$ } = useInboxContext();
  return useCallback(() => overlay$.next({ kind: 'settings' }), [overlay$]);
};

export const useOpenInboxSearch = () => {
  const { overlay$ } = useInboxContext();
  return useCallback(() => overlay$.next({ kind: 'search' }), [overlay$]);
};
